import { Dropdown } from 'BreetComponents';
import { type BankSelectProps, type IDropDownItem, mapBankToDropDownItems } from 'BreetHelpers';
import { selectFiatMeta, useAppSelector, useGetBanksQuery } from 'BreetRedux';
import { type MouseEvent, useCallback, useEffect, useMemo, useState } from 'react';

const BankSelect = ({ onChange, defaultBank = '', label = 'Select Bank', errorMessage, id }: BankSelectProps) => {
	const fiatMeta = useAppSelector(selectFiatMeta);
	const { data } = useGetBanksQuery({ currency: fiatMeta.currencyLower });

	const banks = data?.data;

	const mappedBanks = useMemo(() => banks?.map(mapBankToDropDownItems) ?? [], [banks]);

	const [selectedBank, setSelectedBank] = useState<IDropDownItem | undefined>();

	useEffect(() => {
		setSelectedBank(defaultBank ? mappedBanks.find((c) => c.value === defaultBank) : undefined);
	}, [mappedBanks, defaultBank]);

	const handleBankSelect = useCallback(
		(item: IDropDownItem) => (e: MouseEvent<HTMLButtonElement>) => {
			e.stopPropagation();
			setSelectedBank(item);
			if (item.id) onChange?.(item.id);
		},
		[onChange]
	);

	return (
		<Dropdown.Default
			handleItemSelect={handleBankSelect}
			selectedItem={selectedBank}
			label={label}
			id={id}
			items={mappedBanks}
			iconAs='image'
			placeholder='Search Banks'
			hideValue
			errorMessage={errorMessage}
		/>
	);
};

export default BankSelect;
